export enum EducationalFormFilterOptionValue {
	ACADEMIC_COURSE = 'academic',
	CONFERENCE_SEMINAR = 'conference',
	SUMMER_SCHOOL = 'summer_school',
	WINTER_SCHOOL = 'winter_school',
	SEMESTER_STUDY_ABROAD = 'semester',
	SKILL_PROFESSIONAL_COURSE = 'skill',
}
